module.exports = __webpack_public_path__ + "static/media/orddiktat-intro.4a5784eb.mp3";